import React from "react";
import ReactECharts from 'echarts-for-react';

const SERVICE_COLORS = {
  TTT: "#1e6c56",
  TTS: "#c99718",
  STT: "#00b074",
  STS: "#ff8a3d",
};

const TokenUsageDonutChart = ({ serviceUsage = {} }) => {
  const data = [
    { value: serviceUsage.TTT || 0, name: "Text-To-Text", itemStyle: { color: SERVICE_COLORS.TTT } },
    { value: serviceUsage.TTS || 0, name: "Text-To-Speech", itemStyle: { color: SERVICE_COLORS.TTS } },
    { value: serviceUsage.STT || 0, name: "Speech-To-Text", itemStyle: { color: SERVICE_COLORS.STT } },
    { value: serviceUsage.STS || 0, name: "Speech Translations", itemStyle: { color: SERVICE_COLORS.STS } },
  ];

  const option = {
    tooltip: { trigger: "item", formatter: "{b}: {c} tokens ({d}%)" },
    series: [
      {
        name: "Token Usage",
        type: "pie",
        radius: ["52%", "78%"],
        center: ["50%", "50%"],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 6, borderColor: "#fff", borderWidth: 3 },
        label: { show: false },
        data
      }
    ]
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 flex flex-col justify-between">
      <h3 className="text-xl font-bold text-gray-900 mb-2">Token Usage Across All Services</h3>
      <div className="h-64 flex items-center justify-center">
        <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
      </div>
      <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 pt-2 text-xs font-semibold text-gray-700">
        <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#1e6c56]" /><span>Text-To-Text</span></div>
        <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#c99718]" /><span>Text-To-Speech</span></div>
        <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#00b074]" /><span>Speech-To-Text</span></div>
        <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#ff8a3d]" /><span>Speech Translations</span></div>
      </div>
    </div>
  );
};

export default TokenUsageDonutChart;
